function round(value, precision) {
	var multiplier = Math.pow(10, precision || 0);
	return Math.round(value * multiplier) / multiplier;
}

export function roundPrice(price: number): number {
	if (price === 0) {
		return 0;
	}

	if (price >= 1000000) {
		return round(price / 1000000, 1);
	}

	let remainder = price % 1000;
	var baseNumber;
	if (price != remainder) {
		baseNumber = price - remainder;
	}
	else {
		baseNumber = price;
	}

	if (remainder >= 500) {
		return (baseNumber + 1000) / 1000;
	} else {
		return baseNumber / 1000;
	}
}
